import { render } from "./instructor-tickets.vue?vue&type=template&id=28a4b07f"
import script from "./instructor-tickets.vue?vue&type=script&lang=js"
export * from "./instructor-tickets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__